import React from "react";
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const useAuth = () => {
  return !!localStorage.getItem('accessToken');
}

const PublicRoutes = () => {
  const auth = useAuth();
  let location = useLocation();

  // If logged in, redirect to home page (not login)
  return auth ? <Navigate to="/" replace state={{ from: location }} /> : <Outlet />;
}
export default PublicRoutes;